import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'

const SpinPaceWideget = ({ data }) => {
  const paceWickets = data?.nWicketsPace || 0
  const spinWickets = data?.nWicketsSpin || 0

  const totalWickets = paceWickets + spinWickets

  const pacePercentage = totalWickets > 0 ? (paceWickets / totalWickets) * 100 : 0
  const spinPercentage = totalWickets > 0 ? (spinWickets / totalWickets) * 100 : 0

  return (
        <>
            <h6>Pace vs Spin on Venue <span className={styles.subHeading}>(Last 10 matches)</span> </h6>
            <div className="common-box">
                <div className={`d-flex justify-content-between m-4 ${styles.box}`}>
                    <div className={`d-flex flex-column ${styles.teamName} text-end`}>
                        <h3 className={styles.teamName}>
                            <span>Pace</span></h3>
                        <span className={styles.wicket} style={{ color: '#F25724' }}>
                            {paceWickets} Wkt
                        </span>
                    </div>

                    <div className={`w-100 d-flex flex-column align-items-center justify-content-center ${styles.barLine}`}>
                        <div className="d-flex w-100 flex-row">
                            <div
                                className={`${styles.bar} rounded-start`}
                                style={{ width: `${pacePercentage}%`, background: '#F25724' }}
                            ></div>

                            <div
                                className={`${styles.bar} rounded-end`}
                                style={{ width: `${spinPercentage}%`, background: '#262774' }}
                            ></div>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                            <span className={styles.percent} style={{ color: '#F25724' }}>
                                {pacePercentage.toFixed(2)}%
                            </span>
                            <span className={styles.percent} style={{ color: '#262774' }}>
                                {spinPercentage.toFixed(2)}%
                            </span>
                        </div>
                    </div>

                    <div className={`d-flex flex-column ${styles.teamName} text-start`}>
                        <h6 className={styles.teamName}>
                        <span>Spin</span></h6>
                        <div className={styles.wicket} style={{ color: '#F25724' }}>
                            {spinWickets} Wkt
                        </div>
                    </div>
                </div>
            </div>
        </>
  )
}

SpinPaceWideget.propTypes = {
  data: PropTypes.array.isRequired
}

export default SpinPaceWideget
